import i18n from '@/langs/i18n.js';

export default [
  {
    text: i18n.t('customerStatuses.draft'),
    value: 'DRAFT'
  },
  {
    text: i18n.t('customerStatuses.invited'),
    value: 'INVITED'
  },
  {
    text: i18n.t('customerStatuses.invitationConfirmed'),
    value: 'INVITATION_CONFIRMED'
  }
]
